import { useEffect, useSyncExternalStore } from 'react';
import zh from './companion-zh.json';
export type UiLocale = 'en' | 'zh';
const KEY = 'airbotix:language';
const listeners = new Set<() => void>();
function initial(): UiLocale {
  if (typeof window === 'undefined') return 'en';
  try {
    const value = new URLSearchParams(location.search).get('lang') || localStorage.getItem(KEY);
    return value === 'zh' ? 'zh' : 'en';
  } catch {
    return 'en';
  }
}
let locale: UiLocale = initial();
export const getUiLocale = () => locale;
export function setUiLocale(value: UiLocale) {
  if (value !== 'en' && value !== 'zh') return;
  locale = value;
  try {
    localStorage.setItem(KEY, value);
  } catch {
    /* Current session can still switch. */
  }
  if (typeof document !== 'undefined')
    document.documentElement.lang = value === 'zh' ? 'zh-CN' : 'en';
  listeners.forEach((listener) => listener());
}
if (typeof window !== 'undefined')
  window.addEventListener('storage', (event) => {
    if (event.key === KEY) setUiLocale(event.newValue === 'zh' ? 'zh' : 'en');
  });
export const subscribeUiLocale = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
export function useUiLocale() {
  const value = useSyncExternalStore(subscribeUiLocale, getUiLocale, () => 'en' as UiLocale);
  useEffect(() => {
    document.documentElement.lang = value === 'zh' ? 'zh-CN' : 'en';
  }, [value]);
  return value;
}
const messages: Record<string, string> = zh;
const reverse = Object.fromEntries(Object.entries(messages).map(([en, value]) => [value, en]));
/** Only interface copy calls this; user names, messages, memories and works remain original. */
export function t(text: string): string {
  const canonical = reverse[text] || text;
  return locale === 'zh' ? messages[canonical] || text : canonical;
}
